import React, { type ReactNode } from 'react';
import type { TenantContext } from '@jira/platform__tenant-context-types/src/tenant-context.tsx';
import { TenantContextSubscriber } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';
import { RedirectToLoginPage } from '../../redirect/login/index.tsx';

export type Props = {
	children: ReactNode;
};

/**
 * Imperative Authorisation Check
 */
export const checkAuthentication = (tenantContext: TenantContext): boolean =>
	Boolean(tenantContext.atlassianAccountId);

export const AuthenticationCheck = ({ children }: Props): React.JSX.Element => (
	<TenantContextSubscriber>
		{({ tenantContext }) => {
			if (checkAuthentication(tenantContext)) {
				return children;
			}
			return <RedirectToLoginPage />;
		}}
	</TenantContextSubscriber>
);
